export const validateEmail = (email) => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validateUrl =
  '(http:\\/\\/)?(https:\\/\\/)?(www\\.)?[a-zA-Z0-9\-]+\\.[a-z]{2,4}[^ \n]*\\s*';

export const invalidUrlError =
  'Enter a valid URL. Examples: https://website.com, www.website.com, website.com';

// Product-specific icons for Google services. The generic favicon service
// returns the plain "G" for every *.google.com host, so we override with the
// known per-product favicons hosted on ssl.gstatic.com.
const GOOGLE_PRODUCT_ICONS = {
  docs: 'https://ssl.gstatic.com/docs/documents/images/kix-favicon-2023q4.ico',
  sheets: 'https://ssl.gstatic.com/docs/spreadsheets/favicon3.ico',
  slides: 'https://ssl.gstatic.com/docs/presentations/images/favicon5.ico',
  forms: 'https://ssl.gstatic.com/docs/forms/device_home/android_192.png',
  drive: 'https://ssl.gstatic.com/images/branding/product/1x/drive_2020q4_32dp.png',
  meet: 'https://ssl.gstatic.com/meet/google_meet_horiz_wordmark_2020q4_1x_icon_124_40_4cf86fe1f146bd9a1c1ab8a8b7064e94.png',
  calendar: 'https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_1_2x.png',
  maps: 'https://maps.gstatic.com/favicon3.ico',
  gmail: 'https://ssl.gstatic.com/ui/v1/icons/mail/rfr/gmail.ico',
};

function googleProductIcon(host, pathname) {
  if (host === 'docs.google.com') {
    if (pathname.startsWith('/document')) return GOOGLE_PRODUCT_ICONS.docs;
    if (pathname.startsWith('/spreadsheets')) return GOOGLE_PRODUCT_ICONS.sheets;
    if (pathname.startsWith('/presentation')) return GOOGLE_PRODUCT_ICONS.slides;
    if (pathname.startsWith('/forms')) return GOOGLE_PRODUCT_ICONS.forms;
    return GOOGLE_PRODUCT_ICONS.docs;
  }
  if (host === 'drive.google.com') return GOOGLE_PRODUCT_ICONS.drive;
  if (host === 'sheets.google.com') return GOOGLE_PRODUCT_ICONS.sheets;
  if (host === 'slides.google.com') return GOOGLE_PRODUCT_ICONS.slides;
  if (host === 'forms.google.com') return GOOGLE_PRODUCT_ICONS.forms;
  if (host === 'meet.google.com') return GOOGLE_PRODUCT_ICONS.meet;
  if (host === 'calendar.google.com') return GOOGLE_PRODUCT_ICONS.calendar;
  if (host === 'mail.google.com') return GOOGLE_PRODUCT_ICONS.gmail;
  if (host.endsWith('maps.google.com') || host === 'www.google.com' /* sometimes maps */) {
    // leave www.google.com to default favicon service
  }
  return null;
}

export function faviconUrl(link, size = 16) {
  if (!link) return '';
  let host = '';
  let pathname = '';
  try {
    const u = new URL(link);
    host = u.hostname;
    pathname = u.pathname || '';
  } catch {
    host = String(link).replace(/^[a-z]+:\/\//i, '').split(/[/?#]/)[0];
  }
  if (!host) return '';

  const productIcon = googleProductIcon(host, pathname);
  if (productIcon) return productIcon;

  return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=${size}`;
}

export function capitalizeFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function lowercaseFirstLetter(string) {
  if (!string) return string;
  return string.charAt(0).toLowerCase() + string.slice(1);
}

export function generateId() {
  return '_' + Math.random().toString(36).substr(2, 9);
}

export function isValidDate(d) {
  return d instanceof Date && !isNaN(d);
}

export function displayTime(isoString) {
  if (!isoString) return '';
  return new Date(isoString).toLocaleString();
}
